import apiFetch from '../apiFetch'

export default function (token, documentId) {
  return apiFetch({ endPoint: `document/${documentId}/sheet`, method: 'GET', body: null, token: token })
}
